module.exports = __webpack_public_path__ + "assets/img/MetaXar-Games.1e264523.svg";